<template>
  <tr>
    <td>
      <a
        v-if="hasActionableRows"
        :href="approvalUrl"
        v-text="upload.attributes.original_filename"
      />
      <span
        v-else
        v-text="upload.attributes.original_filename"
      />
    </td>
    <td v-text="upload.attributes.total_row_count" />
    <td>
      <a
        v-if="hasActionableRows"
        :href="approvalUrl"
        v-text="pendingApprovalCount"
      />
      <span
        v-else
        v-text="'0'"
      />
    </td>
    <td v-text="upload.attributes.pending_row_count" />
    <td>
      <a
        v-if="upload.attributes.imported_row_count"
        :href="`${logUrl}/?rowStatus=imported`"
        v-text="upload.attributes.imported_row_count"
      />
      <span
        v-else
        v-text="'0'"
      />
    </td>
    <td>
      <a
        v-if="warningCount"
        :href="`${logUrl}/?rowStatus=warned`"
        v-text="warningCount"
      />
      <span
        v-else
        v-text="'0'"
      />
    </td>
    <td>
      <a
        v-if="errorCount"
        :href="`${logUrl}/?rowStatus=failed`"
        v-text="errorCount"
      />
      <span
        v-else
        v-text="'0'"
      />
    </td>
    <td>
      <a
        :href="logUrl"
        class="btn btn--sm"
        v-text="'Logs'"
      />
    </td>
  </tr>
</template>

<script type="text/babel">
export default {
  name: 'ImportHistoryRow',
  props: {
    upload: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasActionableRows() {
      return this.pendingApprovalCount >= 1
    },
    baseUrl() {
      return this.$urlGenerator.active(`members/imports/${this.upload.uuid}`)
    },
    pendingApprovalCount() {
      return this.upload.attributes.pending_processing_row_count
    },
    approvalUrl() {
      return this.baseUrl
    },
    logUrl() {
      return `${this.baseUrl}/logs`
    },
    errorCount() {
      return this.upload.attributes.failed_row_count
    },
    warningCount() {
      return this.upload.attributes.warning_row_count
    },
  },
}
</script>
